<div class="white_round padding_sides16">
    <ng-container *ngFor="let iTemplate of ns.loadedSetupTemplates">
        <app-button-single-line-arrow (click)="onSelectionMade(iTemplate)">{{iTemplate.name}}</app-button-single-line-arrow>
    </ng-container>
    <p *ngIf="noTemplates && !trk8Device" class="padding16">{{trans('setup.device.noTemplatesConfigured')}}</p>
    <p *ngIf="noTemplates && trk8Device" class="padding16">{{trans('setup.device.noTemplatesConfiguredTrk8')}}</p>
</div>